<div class="container">
  <!-- Been here before -->
  @if (!isLoggedIn && regex) {
  <div class="row">
    <div class="col-12 col-lg-6">
      <h2 class="fs-23 mb-2 pt-2 text-col40 fw400">Been here before?</h2>
      <div class="fs-17 mb-3">Have you compared or switched Energy here before? Save yourself some time by going
        straight to your dashboard.</div>
      <button [id]="id + '_UsedOurEnergyToolsBefore_SignIn'" class="btn btn-primary-outline" type="button"
        (click)="signIn()">Sign in</button>
    </div>
  </div>
  }
  <!-- Your Details -->
  @if (regex) {
  <div class="row">
    <div class="col-12 col-lg-6">
      <h4 class="my-4 fs-17">Your details</h4>
      <hr>
    </div>
  </div>
  }

  @if (regex) {
  <!-- Postcode lookUp -->
  <div class="row">
    <div class="col-12 col-md-6">
      <h3 class="fs-23 mb-2 pt-2 text-col40 fw400">What is your address?</h3>
      <app-postcode-lookup [isHomePage]="true" [isIndividual]="true" [regex]="regex" [isReset]="isReset"
        (resetComplete)="isReset = $event" (addedNewAddress)="getAddressDetails($event)"></app-postcode-lookup>
      @if (selectedAddress) {
      <!-- Selected address -->
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="boxTyp7 p-3">{{selectedAddress?.addressText}}</div>
          <button class="btn btn-secondary-link" type="button" (click)="resetAddress()">Change address</button>
        </div>
      </div>
      }
      <hr>
    </div>
  </div>

  @if (!isLoggedIn) {
  <form [formGroup]="consentFormGroup">
    <!-- Email confirmation -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 pt-2 text-col40 fw400">What is your email?</h3>
        <div class="fs-17 mb-3">The energy provider needs this to send you confirmation of your switch. If you opt-in to
          receive emails from us, we’ll send you those too.</div>
        <div
          [ngClass]="!consentFormGroup?.get('email')?.valid && consentFormGroup?.get('email')?.touched ? 'error-bar' : ''">
          <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
            appearance="fill" subscriptSizing="dynamic">
            <input autocomplete="email" [id]="id + '_email'" matInput
              class="cy-email inputTyp2 fw500 sessioncamexclude sessioncamhidetext maskpii" formControlName="email"
              type="text" aria-label="Enter your email address." maxlength="256" appBlockCopyPaste
              (focus)="tealiumDataSet('focus')" (blur)="tealiumDataSet('blur')" />
            <mat-error aria-hidden="true" class="ctm-error"
              *ngIf="!consentFormGroup?.get('email')?.valid && consentFormGroup?.get('email')?.touched">
              <span *ngIf="consentFormGroup?.get('email')?.hasError('required')">Email is required</span>
              <span *ngIf="consentFormGroup?.get('email')?.hasError('pattern')"> Invalid email address</span>
              <span *ngIf="consentFormGroup?.get('email')?.hasError('invalid')"> {{
                consentFormGroup?.get('email')?.getError('invalid') }}</span>
            </mat-error>
          </mat-form-field>
        </div>
        <hr>
      </div>
    </div>
    <!-- CTM Marketing consent -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 pt-2 text-col40 fw400">{{ supplierConfig?.CTMMarketingConsent?.title }}</h3>
        <div class="contact-consent my-3" [innerHTML]="supplierConfig?.CTMMarketingConsent?.description"></div>
        <div class="radioBtnTyp1 fs-17 checkbox-radio-group" [ngClass]="!consentFormGroup?.get('consent')?.valid &&
          consentFormGroup?.get('consent')?.touched ? 'error-bar' : ''">
          @for (option of marketingConsentList; track option?.id) {
          <div class="mb-1">
            <mat-checkbox [id]="id + '_ChooseHowWeContactYou_' + option?.name?.replaceAll(' ', '_')" type="checkbox"
              class="cy-consent ctm-checkbox-large" color="primary" [(value)]="option.name"
              [checked]="option?.isChecked"
              (change)="selectedMarketingConsent($event, option)">{{option?.name}}</mat-checkbox>
          </div>
          }
          <mat-error class="ctm-error"
            *ngIf="!consentFormGroup?.get('consent')?.valid && consentFormGroup?.get('consent')?.touched">
            Please select one of the options to continue
          </mat-error>
        </div>
        @if (supplierConfig?.CTMMarketingConsent?.consentHint?.isVisible) {
        <div>
          <mat-accordion class="example-headers-align">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title [id]="id + '_consentHint'" class="cy-consent-hint elink">
                  {{ supplierConfig?.CTMMarketingConsent?.consentHint?.title }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              {{ supplierConfig?.CTMMarketingConsent?.consentHint?.description }}
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        }
      </div>
    </div>
  </form>
  }
  } @else {
  <div class="skeleton-wrapper">
    <div class="container px-0">
      <div class="skeleton-wrapper-inner px-0">
        <div class="skeleton-wrapper-body">
          <div class="row noBG">
            <div class="col-12 col-lg-6 noBG">
              <div class="bg-col2 h-100 text-center">
                <div class="p-3 w-50"></div>
                <div class="p-4 mt-3"></div>
                <hr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="skeleton-wrapper">
    <div class="container px-0">
      <div class="skeleton-wrapper-inner px-0">
        <div class="skeleton-wrapper-body">
          <div class="row noBG">
            <div class="col-12 col-lg-6 noBG">
              <div class="bg-col2 h-100 text-center">
                <div class="p-3 w-50"></div>
                <div class="p-2 mt-3 w-25"></div>
                <div class="p-1 mt-2"></div>
                <div class="p-1 mt-2 w-50"></div>
                <div class="p-2 mt-3 w-25"></div>
                <div class="p-1 mt-2"></div>
                <div class="p-1 mt-2 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <hr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Terms -->
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="term mb-2rem">
        We share your information with third parties, which includes retrieving your current and previous energy
        information. By continuing you accept our <a class="elink"
          href="https://www.comparethemarket.com/information/terms-and-conditions/" target="_blank">terms and
          conditions</a>, which includes confirming you have the bill-payers permission to access the data. Please see
        our
        <a class="elink" href="https://www.comparethemarket.com/information/privacy-policy/" target="_blank">privacy
          policy</a> to understand how we will use your information to provide the service to you.
      </div>
    </div>
  </div>

  <!-- Footer buttons -->
  <div class="footer-container" [ngClass]="{'sticky-above-footer': isFooterSticky, 'above-footer': !isFooterSticky}">
    <div class="mt-3 pt-3 row border-2 border-top">
      <div class="col-12 col-lg-6">
        <div class="btn-container d-grid d-lg-flex justify-content-lg-between gap-3 gap-lg-0 mb-2">
          <button id="backButton" class="btn btn-primary-outline order-2 order-lg-1" type="button"
            (click)="back()">Back</button>
          <button id="nextButton" class="btn btn-primary order-1 order-lg-2" type="button"
            [ngClass]="isSubmitting ? 'animate' : ''"
            [disabled]="!isLoggedIn ? (!selectedAddress || !regex || isSubmitting || consentFormGroup?.invalid || !isCurrentUsageLoaded)  : (!selectedAddress || isSubmitting || !regex || !isCurrentUsageLoaded)"
            (click)="submit()">
            <span class="spinner"></span>
            <span class="text">Next</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <button [id]="id + '_UsedOurEnergyToolsBefore_ReadOurFaqs'" class="btn btn-secondary-link ps-0 mb-3"
    (click)="navigateToURL('/frequently-ask-question')">Read our FAQs</button> -->
</div>